export enum QueryStatus {
  idle = 'idle',
  loading = 'loading',
  success = 'success',
  error = 'error'
}
